module.exports = __webpack_public_path__ + "static/img/ent-24.0abc5bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-24.jpg
// module id = wOeV
// module chunks = 51